// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2x2aM","container":"styles_container__3ufr1","title":"styles_title__3YS3E","wrapper":"styles_wrapper__qaV1M","answer":"styles_answer__2xFQN"};